import { Box, styled } from "@mui/material";
import MuiButton from "@mui/material/Button";

export const StyledBigButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    prop !== "isSelected" && prop !== "isFullWidth" && prop !== "alignment",
})<{
  isSelected?: boolean;
  isFullWidth?: boolean;
  alignment?: "center" | "start" | "end";
}>`
  text-transform: initial;
  transition: all 0.15s;
  overflow: hidden;
  width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "auto")};
  padding: ${({ theme }) => theme.wsc.spacing[2]};
  display: flex;
  flex-direction: column;
  align-items: ${({ alignment }) => alignment};
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  border-radius: ${({ theme }) => theme.wsc.radius.m};
  background-color: ${({ theme }) => theme.wsc.palette.neutral[700]};
  border: 1px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.wsc.palette.primary[300] : "transparent"};
  color: ${({ isSelected, theme }) =>
    isSelected
      ? theme.wsc.palette.primary[300]
      : theme.wsc.palette.neutral[100]};

  ${({ theme }) => theme.wsc.typography.body1};

  &&& span {
    color: ${({ isSelected, theme }) =>
      isSelected
        ? theme.wsc.palette.primary[300]
        : theme.wsc.palette.neutral[100]};
  }

  :active {
    border-color: ${({ theme }) => theme.wsc.palette.primary[500]};
    color: ${({ theme }) => theme.wsc.palette.primary[500]};
    &&& span {
      color: ${({ theme }) => theme.wsc.palette.primary[500]};
    }
  }

  :hover {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
  }

  :disabled {
    color: ${({ theme, isSelected }) =>
      isSelected
        ? theme.wsc.palette.primary[700]
        : theme.wsc.palette.neutral[400]};
    &&& span {
      color: ${({ theme, isSelected }) =>
        isSelected
          ? theme.wsc.palette.primary[700]
          : theme.wsc.palette.neutral[400]};
    }
    border-color: ${({ theme, isSelected }) =>
      isSelected ? theme.wsc.palette.primary[700] : "transparent"};
    background-color: transparent;
  }
`;

export const StyledLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== "wrapMode",
})<{ wrapMode: "wrap" | "ellipsis" }>`
  width: 100%;
  overflow: hidden;
  white-space: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "nowrap" : "pre-wrap"};
  text-overflow: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "ellipsis" : "initial"};
  word-break: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "initial" : "break-word"};
`;
